import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format, parse, parseISO } from "date-fns";
import { Star1 } from "iconsax-reactjs";

import * as APIDashboard from "../../../../services/nps/functions";

import { ReactComponent as ArrowDowRedIcon } from "../../../../build/images/nps-dashboard-icons/arrow_drop_down-red.svg";
import { ReactComponent as ArrowDowGreenIcon } from "../../../../build/images/nps-dashboard-icons/arrow_drop_down-green.svg";
import { ReactComponent as EmailIcon } from "../../../../build/new-midias-icons/email.svg";
import { ReactComponent as GbmIcon } from "../../../../build/images/nps-dashboard-icons/channels/gbm.svg";
import { ReactComponent as MessengerIcon } from "../../../../build/new-midias-icons/messenger.svg";
import { ReactComponent as SmsIcon } from "../../../../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TelegramIcon } from "../../../../build/new-midias-icons/telegram.svg";
import { ReactComponent as VoiceIcon } from "../../../../build/new-midias-icons/voz.svg";
import { ReactComponent as WebchatIcon } from "../../../../build/images/nps-dashboard-icons/channels/webchat.svg";
import { ReactComponent as WhatsappIcon } from "../../../../build/new-midias-icons/whatsapp.svg";

import "./nps-date-four.css";
import Paperplane from "../../../Loading/Paperplane";
import { ptBR } from "date-fns/locale";
import { subAndFormatMonths } from "../../../../utils/subAndFormatMonths";

export default function NpsDateFour() {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const cardsOfQualityDash = useSelector((state) => state.cardsOfQualityDash);

  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [csatValues, setCsatValues] = useState({
    csatMes: 0,
    csatPassado: 0,
    mesPassado: false,
  });
  const [channelsValue, setChannelsValue] = useState({
    voz: 0,
    whatsapp: 0,
    gbm: 0,
    messenger: 0,
    email: 0,
    sms: 0,
    telegram: 0,
    webchat: 0,
  });
  const [dispareFilter, setDispareFilter] = useState(false);
  const [loading, setLoading] = useState(false);

  const csatChannelData = [
    {
      icon: <WhatsappIcon />,
      percentage: channelsValue.whatsapp,
      channel: "Whatsapp",
    },
    { icon: <SmsIcon />, percentage: channelsValue.sms, channel: "Sms" },
    { icon: <EmailIcon />, percentage: channelsValue.email, channel: "E-mail" },
    { icon: <VoiceIcon />, percentage: channelsValue.voz, channel: "Voz" },
    {
      icon: <TelegramIcon />,
      percentage: channelsValue.telegram,
      channel: "Telegram",
    },
    {
      icon: <MessengerIcon />,
      percentage: channelsValue.messenger,
      channel: "Messenger",
    },
  ];

  function renderPastPeriodInformation(csatValues) {
    const isPastCsatNegative = csatValues.csatPassado < 0;
    if (isPastCsatNegative) {
      return (
        <span className="csat-month-content__span">
          <ArrowDowRedIcon />

          <h5 className="csat-month-content__span__number">
            {csatValues.csatPassado}%
          </h5>
          <h5 className="csat-month-content__span__text">vs</h5>
          <h5 className="csat-month-content__span__text">
            {csatValues.mesPassado}
          </h5>
        </span>
      );
    }

    const isPastCsatPositive = csatValues.csatPassado > 0;
    if (isPastCsatPositive) {
      return (
        <span className="csat-month-content__span">
          <h5 className="csat-month-content__span__number csat-month-content__span__number--green">
            {csatValues.csatPassado}%
          </h5>
          <h5 className="csat-month-content__span__text">vs</h5>
          <h5 className="csat-month-content__span__text">
            {csatValues.mesPassado}
          </h5>
        </span>
      );
    }
    return null;
  }

  async function getCsatResultV2() {
    let updatedCsatValues = {
      csatMes: 0,
      csatPassado: 0,
      mesPassado: false,
    };
    const responseCurrentDate = await APIDashboard.getSentNpsCsat(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );
    const hasResponseCurrentDate =
      !!responseCurrentDate && responseCurrentDate.status === 200;
    if (hasResponseCurrentDate) {
      const data = responseCurrentDate.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        const csatInfos = data.find((datum) => {
          return datum.tipo_pesquisa === "CSAT";
        });
        const hasCsatInfos = !!csatInfos;
        if (hasCsatInfos) {
          const grade = Number(csatInfos.nota);
          const isGradeANumber = typeof grade === "number";
          if (isGradeANumber) {
            updatedCsatValues.csatMes = grade;
          }
        }
      }
    }

    const initialDateOfPastMonth = subAndFormatMonths(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      1,
    );
    const finalDateOfPastMonth = subAndFormatMonths(
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      1,
    );
    const responsePastMonth = await APIDashboard.getSentNpsCsat(
      initialDateOfPastMonth,
      finalDateOfPastMonth,
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );
    const hasResponsePastMonth =
      !!responsePastMonth && responsePastMonth.status === 200;
    if (hasResponsePastMonth) {
      const data = responsePastMonth.data;
      const hasData = !!data && data.length > 0;
      if (hasData) {
        const csatInfos = data.find((datum) => {
          return datum.tipo_pesquisa === "CSAT";
        });
        const hasCsatInfos = !!csatInfos;
        if (hasCsatInfos) {
          const pastValue = Number(csatInfos.nota);
          const isPastValueANumber = typeof pastValue === "number";

          if (isPastValueANumber) {
            const dateStartObj = parseISO(initialDateOfPastMonth);
            let formatedStartDate = "";
            const isDateStartObjValid = !!dateStartObj;
            if (isDateStartObjValid) {
              formatedStartDate = format(dateStartObj, "dd/MM/yyyy");
            }

            const dateEndObj = parseISO(finalDateOfPastMonth);
            let formatedEndDate = "";
            const isDateEndObjValid = !!dateEndObj;
            if (isDateEndObjValid) {
              formatedEndDate = format(dateEndObj, "dd/MM/yyyy");
            }
            const currentValue = updatedCsatValues.csatMes;
            const comparation = currentValue - pastValue;
            updatedCsatValues.csatPassado = comparation;
            updatedCsatValues.mesPassado = (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span>{formatedStartDate}</span>
                <span>{formatedEndDate}</span>
              </div>
            );
          }
        }
      }
    }

    setCsatValues(updatedCsatValues);
  }

  async function getCsatResult() {
    const response = await APIDashboard.getCsatResult(
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response && response.status === 200) {
      const data = response.data;
      data.forEach((datum) => {
        datum.mes = datum.mes.replace("-", "/");
      });

      if (data.length > 1) {
        const monthCsat = data.filter((datum) => {
          const monthDate = parse(datum.mes, "yyyy/MM", new Date());
          return new Date().getMonth() === monthDate.getMonth();
        });
        const pastCsat = data.filter((datum) => {
          const monthDate = parse(datum.mes, "yyyy/MM", new Date());
          return new Date().getMonth() !== monthDate.getMonth();
        });
        const date = parse(pastCsat[0].mes, "yyyy/MM", new Date());
        setCsatValues({
          csatMes: monthCsat[0].resultado,
          csatPassado: monthCsat[0].resultado - pastCsat[0].resultado,
          mesPassado: format(date, "MMMM", {
            locale: ptBR,
          }),
        });
      } else if (data.length === 1) {
        const date = parse(data[0].mes, "yyyy/MM", new Date());
        setCsatValues({
          ...csatValues,
          csatMes: data[0].resultado,
          mesPassado: format(date, "MMMM", { locale: ptBR }),
        });
      } else {
        setCsatValues({
          csatMes: 0,
          csatPassado: 0,
          mesPassado: false,
        });
      }
      // setCompilation(data[0]);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  async function getCsatChannel() {
    const response = await APIDashboard.getCsatChannel(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.business.map((option) => option.id).join(),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.questionsNPS.map((option) => option.id).join(),
      filtersDashboard.questionsCSAT.map((option) => option.id).join(),
      filtersDashboard.channels.map((option) => option.id).join(),
    );

    if (response && response.status === 200) {
      const data = response.data;

      let objValues = {
        voz: 0,
        whatsapp: 0,
        gbm: 0,
        messenger: 0,
        email: 0,
        sms: 0,
        telegram: 0,
        webchat: 0,
      };

      if (data.length > 0) {
        data.forEach((datum) => {
          switch (datum.idmidia) {
            case 1:
              objValues = { ...objValues, voz: datum.resultado };
              break;
            case 7:
              setChannelsValue({ ...channelsValue, webchat: datum.resultado });
              break;
            case 3:
              objValues = { ...objValues, email: datum.resultado };
              break;
            case 4:
              objValues = { ...objValues, messenger: datum.resultado };
              break;
            case 5:
              objValues = { ...objValues, whatsapp: datum.resultado };
              break;
            case 8:
              objValues = { ...objValues, telegram: datum.resultado };
              break;
            case 11:
              objValues = { ...objValues, gbm: datum.resultado };
              break;
            case 12:
              objValues = { ...objValues, sms: datum.resultado };
              break;
            default:
              break;
          }
        });

        setChannelsValue(objValues);
      } else {
        setChannelsValue({
          voz: 0,
          whatsapp: 0,
          gbm: 0,
          messenger: 0,
          email: 0,
          sms: 0,
          telegram: 0,
          webchat: 0,
        });
      }
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde.",
      );
      //   Toast(
      //     "Falha, não foi possível carregar as informações!",
      //     "Verifique sua conexão e tente novamente mais tarde",
      //     "error"
      //   );
    }
  }

  const getAllData = async () => {
    setLoading(true);
    await getCsatResultV2();
    await getCsatChannel();
    setDispareFilter(true);
    setLoading(false);
  };

  useEffect(() => {
    if (!cardsOfQualityDash.card12) return;

    if (!dispareFilter || filtersDashboard.active) {
      setLoading(true);
      getCsatResultV2().finally(() => setLoading(false));
      if (!dispareFilter) setDispareFilter(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersDashboard, cardsOfQualityDash.card12]);

  useEffect(() => {
    if (!cardsOfQualityDash.card13) return;

    if (!dispareFilter || filtersDashboard.active) {
      setLoading(true);
      getCsatChannel().finally(() => setLoading(false));
      if (!dispareFilter) setDispareFilter(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersDashboard, cardsOfQualityDash.card13]);

  return (
    (cardsOfQualityDash.card12 || cardsOfQualityDash.card13) && (
      <section className="nps-date-four-quality">
        {cardsOfQualityDash.card12 && (
          <div className="csat-month">
            {loading ? (
              <Paperplane className="nps-date-four__loading" />
            ) : (
              <>
                <div className="cards-headers">
                  <h4>CSAT do Período</h4>
                </div>
                <div className="csat-month-content">
                  <div className="csat-month-content__icon">
                    <Star1 size={24} color="#455CC7" variant="Outline" />
                  </div>
                  <p>
                    <h1 className="csat-month-content__h1">
                      {csatValues.csatMes}%
                    </h1>
                    <h2 className="csat-month-content__h2">Atd realizados</h2>
                  </p>
                  {renderPastPeriodInformation(csatValues)}
                </div>
              </>
            )}
          </div>
        )}

        {cardsOfQualityDash.card13 && (
          <div className="csat-by-channel">
            <header className="csat-by-channel__header">
              <div className="cards-headers">
                <h4>CSAT por canal</h4>
              </div>
            </header>

            <div className="channels-percentage">
              {loading ? (
                <Paperplane className="nps-date-four__loading" />
              ) : (
                csatChannelData.map((data, index) => (
                  <div key={index} className="content-container">
                    <span className="csat-channel-container">{data.icon}</span>

                    <span className="csat-channel-container__span">
                      <h1 className="content-container__number">
                        {data.percentage}%
                      </h1>
                      <h6 className="csat-channel-container__h6">
                        {data.channel}
                      </h6>
                    </span>
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </section>
    )
  );
}
